import { useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import PublicLayout from "@/components/PublicLayout";
import RequestForm from "@/components/RequestForm";
import Confirmation from "@/components/Confirmation";

const TITLES = {
  assistance: ["I need assistance", "Tell us what you or your family need. It only takes a few minutes."],
  talk: ["I need someone to talk to", "Arrange a confidential pastoral conversation with authorized parish personnel."],
  home_visit: ["Request a home visit", "For sick or homebound persons, older parishioners, persons with disabilities, bereaved families, or families requesting prayer."],
};

export default function RequestPage() {
  const { type } = useParams();
  const [result, setResult] = useState(null);
  if (!TITLES[type]) return <Navigate to="/" replace />;
  return (
    <PublicLayout>
      <div className="max-w-3xl mx-auto px-5 py-10 sm:py-14">
        {result ? <Confirmation result={result} /> : (
          <>
            <h1 data-testid="request-page-title" className="text-3xl sm:text-4xl font-black">{TITLES[type][0]}</h1>
            <p className="mt-3 mb-10 text-base md:text-lg text-[#605349]">{TITLES[type][1]}</p>
            <RequestForm type={type} onDone={setResult} />
          </>
        )}
      </div>
    </PublicLayout>
  );
}
